import { render, staticRenderFns } from "./add_subaccountlist_shop.vue?vue&type=template&id=65f74b6a&scoped=true&"
import script from "./add_subaccountlist_shop.vue?vue&type=script&lang=js&"
export * from "./add_subaccountlist_shop.vue?vue&type=script&lang=js&"
import style0 from "./add_subaccountlist_shop.vue?vue&type=style&index=0&id=65f74b6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f74b6a",
  null
  
)

export default component.exports